import { FEATURE_FLAGS } from '@aibees/elephant/constants';
import { CompanyMetadataItem, FeatureFlags } from '@aibees/elephant/types';
import { IconType } from '@aibees/shared/components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { COMPANY_ID_FILTER_SEPARATOR } from '@aibees/elephant/constants/filters';
import { SearchListType } from '@aibees/elephant/hooks/search-list/types';
import { isFeatureEnabled } from '@aibees/shared/feature-flags';
import {
  companySearchIdsLabelParser,
  companySearchLabelParser,
  getBulkSearchFilterFieldTags,
  getDomainIfExist,
} from '../components/filter-tags/utils';
import {
  companyDomainRegexPatterns,
  companyLinkedinUrlRegexPatterns,
  companyNameRegexPatterns,
} from '../constants/config';
import {
  FilterBadgeType,
  FilterCategory,
  SearchFilter,
  SearchFilterBase,
  SearchFilterType,
} from '../types';
import { companySearchApiResponseMapper } from '../utils';
import { bulkUrlValidation } from '../utils/bulk-url-validtion';

export const companyBulkSearchItems = [
  {
    name: 'Bulk Include / Exclude',
    type: SearchFilterType.BULK,
    index: 2,
    layer: 3,
    key: '',
    field: '',
    icon: 'plus',
    metadata: {
      info: 'Combined with bulk list.',
    },
    comingSoon: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.FILTER_COMPANY_BULK_SEARCH
    ),
    items: [
      {
        field: 'bulk_company_social',
        key: 'bulk_company_social',
        index: 0,
        layer: 4,
        name: 'Company Social Link',
        type: SearchFilterType.BULK,
        comingSoon: !isFeatureEnabled(
          FEATURE_FLAGS,
          FeatureFlags.FILTER_COMPANY_BULK_SEARCH
        ),
        metadata: {
          color: 'primary',
          icon: 'block',
          alternate: {
            icon: 'eye-outlined',
            name: 'View All',
          },
          validation: {
            patternValidation: (inputs) =>
              bulkUrlValidation(inputs, companyLinkedinUrlRegexPatterns),
          },
          bulkInput: {
            listType: SearchListType.COMPANY_LINKEDIN,
          },
          dialog: {
            subTitleItemLabel: 'URLs',
            title: 'Bulk Include / Exclude Company Search',
          },
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
            },
          },
        },
        items: [
          {
            field: 'bulk_include_company_social',
            key: 'bulk_include_company_social',
            index: 0,
            layer: 4,
            metadata: {
              color: 'primary',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'URLs',
                textArea: {
                  placeholder: `https://www.linkedin.com/company/apple\nhttp://www.linkedin.com/company/apple\nwww.linkedin.com/company/apple\nlinkedin.com/company/apple`,
                },
              },
            },
            name: 'Include Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
          {
            field: 'bulk_exclude_company_social',
            key: 'bulk_exclude_company_social',
            index: 0,
            layer: 4,
            metadata: {
              color: 'error',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'URLs',
                textArea: {
                  placeholder: `https://www.linkedin.com/company/apple\nhttp://www.linkedin.com/company/apple\nwww.linkedin.com/company/apple\nlinkedin.com/company/apple`,
                },
              },
            },
            name: 'Exclude Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
        ],
      },
      {
        field: 'bulk_company_domain',
        key: 'bulk_company_domain',
        index: 0,
        layer: 4,
        name: 'Company Domain Link',
        type: SearchFilterType.BULK,
        comingSoon: !isFeatureEnabled(
          FEATURE_FLAGS,
          FeatureFlags.FILTER_COMPANY_BULK_SEARCH
        ),
        metadata: {
          color: 'primary',
          icon: 'block',
          alternate: {
            icon: 'eye-outlined',
            name: 'View All',
          },
          validation: {
            patternValidation: (inputs) =>
              bulkUrlValidation(inputs, companyDomainRegexPatterns),
          },
          bulkInput: {
            listType: SearchListType.COMPANY_DOMAIN,
          },
          dialog: {
            subTitleItemLabel: 'URLs',
            title: 'Bulk Include / Exclude Company Search',
          },
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
            },
          },
        },
        items: [
          {
            field: 'bulk_include_company_domain',
            key: 'bulk_include_company_domain',
            index: 0,
            layer: 4,
            metadata: {
              color: 'primary',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'URLs',
                textArea: {
                  placeholder: `www.apple.com\namazon.com\nhttps://www.ai-ark.com\nhttps://ai-bees.io`,
                },
              },
            },
            name: 'Include Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
          {
            field: 'bulk_exclude_company_domain',
            key: 'bulk_exclude_company_domain',
            index: 0,
            layer: 4,
            metadata: {
              color: 'error',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'URLs',
                textArea: {
                  placeholder: `www.apple.com\namazon.com\nhttps://www.ai-ark.com\nhttps://ai-bees.io`,
                },
              },
            },
            name: 'Exclude Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
        ],
      },
      {
        field: 'bulk_company_name',
        key: 'bulk_company_name',
        index: 0,
        layer: 4,
        name: 'Company Name',
        type: SearchFilterType.BULK,
        comingSoon: !isFeatureEnabled(
          FEATURE_FLAGS,
          FeatureFlags.FILTER_COMPANY_BULK_SEARCH
        ),
        metadata: {
          color: 'primary',
          icon: 'block',
          alternate: {
            icon: 'eye-outlined',
            name: 'View All',
          },
          validation: {
            patternValidation: (inputs) =>
              bulkUrlValidation(inputs, companyNameRegexPatterns),
          },
          bulkInput: {
            listType: SearchListType.COMPANY_NAME,
          },
          dialog: {
            subTitleItemLabel: 'Names',
            title: 'Bulk Include / Exclude Company Search',
          },
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
            },
          },
        },
        items: [
          {
            field: 'bulk_include_company_name',
            key: 'bulk_include_company_name',
            index: 0,
            layer: 4,
            metadata: {
              color: 'primary',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'Names',
                textArea: {
                  placeholder: `Intel\nCisco\nSAP\nAMD\nQualcomm`,
                },
              },
            },
            name: 'Include Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
          {
            field: 'bulk_exclude_company_name',
            key: 'bulk_exclude_company_name',
            index: 0,
            layer: 4,
            metadata: {
              color: 'error',
              limit: {
                max: {
                  size: 10000,
                  message:
                    'You can only add up to {0} excluded, remove at least {1} companies to continue.',
                },
              },
              dialog: {
                subTitleItemLabel: 'Names',
                textArea: {
                  placeholder: `Intel\nCisco\nSAP\nAMD\nQualcomm`,
                },
              },
            },
            name: 'Exclude Companies',
            type: SearchFilterType.BULK,
            utils: {
              tags: {
                getFilterItemTagFunc: getBulkSearchFilterFieldTags,
              },
            },
          },
        ],
      },
    ],
  },
] as SearchFilter[];

export default function companySearchFilterConfig(): SearchFilterBase {
  return {
    name: 'Company Search',
    icon: 'search',
    index: 17,
    layer: 3,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    badge: FilterBadgeType.BETA,
    items: [
      {
        name: '',
        type: SearchFilterType.NONE,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Find by companies',
            },
          },
        },
        items: [
          {
            type: SearchFilterType.COMPANY_IDS,
            icon: 'business',
            index: -1,
            field: 'company_search_list_id',
            key: 'company_search_list_id',
            name: 'Selected Companies',
            metadata: {
              color: 'primary',
              delimiter: COMPANY_ID_FILTER_SEPARATOR,
            },
            utils: {
              tags: {
                labelFormatter: companySearchIdsLabelParser,
              },
            },
          },
        ],
      },
      {
        name: 'Manual / Bulk Search',
        type: SearchFilterType.NONE,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Manual Search',
            },
          },
        },
        items: [
          {
            name: 'Include',
            type: SearchFilterType.CUSTOM_SELECT,
            index: 1,
            layer: 4,
            field: 'include_company_ids',
            key: 'include_company_ids',
            metadata: {
              color: 'primary',
              icon: 'add-circle-outline',
              preset: 'company_name',
              placeholder: 'Enter Name or Domain (OR) Search',
              autocomplete: {
                recent: false,
                transformSearchValue: getDomainIfExist,
                checkboxPosition: 'right',
                multiple: true,
                avartarFallbackIcon: 'business',
              },
              delimiter: '::',
              limit: {
                max: {
                  size: 100,
                  message:
                    'Manual company search entry are limited to 100 records, please use the bulk Include/exclude to add more.',
                },
              },
            },
            searchKey: 'search',
            config: { labelKey: 'label', valueKey: 'value' },
            utils: {
              optionsApiFormatter: (
                data?: CompanyMetadataItem[],
                icon?: IconType,
                delimiter?: string
              ) => companySearchApiResponseMapper(data, icon, delimiter),
              tags: { labelFormatter: companySearchLabelParser },
            },
            options: [
              {
                type: 'URL',
                value: `/elephant-management/um/workspaces/:wid/companies/metadata-management?return=list&page=0&size=10&employee_count=desc`,
                label: '',
                icon: null,
                index: undefined,
              },
            ],
          },
          {
            name: 'Exclude',
            type: SearchFilterType.CUSTOM_SELECT,
            index: 2,
            layer: 4,
            key: 'exclude_company_ids',
            field: 'exclude_company_ids',
            metadata: {
              color: 'error',
              icon: 'block',
              preset: 'company_name',
              placeholder: 'Enter Name or Domain (OR) Search',
              autocomplete: {
                recent: false,
                transformSearchValue: getDomainIfExist,
                checkboxPosition: 'right',
                multiple: true,
                avartarFallbackIcon: 'business',
              },
              delimiter: '::',
              limit: {
                max: {
                  size: 100,
                  message:
                    'Manual company search entry are limited to 100 records, please use the bulk Include/exclude to add more.',
                },
              },
            },
            searchKey: 'search',
            config: { labelKey: 'label', valueKey: 'value' },
            utils: {
              optionsApiFormatter: (
                data?: CompanyMetadataItem[],
                icon?: IconType,
                delimiter?: string
              ) => companySearchApiResponseMapper(data, icon, delimiter),
              tags: { labelFormatter: companySearchLabelParser },
            },
            options: [
              {
                type: 'URL',
                value: `/elephant-management/um/workspaces/:wid/companies/metadata-management?return=list&page=0&size=10&employee_count=desc`,
                label: '',
                icon: null,
                index: undefined,
              },
            ],
          },
        ],
      },
      {
        name: 'Bulk Manual Search',
        type: SearchFilterType.NONE,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        items: companyBulkSearchItems,
      },
    ],
  };
}
